import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-rating',
    templateUrl: './rating.component.html',
    styleUrls: [
        './rating.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RatingComponent implements OnInit
{
  @Input() id: string;
  @Input() rating: number = 0;
  @Output() ratingClick: EventEmitter<any> = new EventEmitter<any>();

   inputName: string;
   ngOnInit ()
   {
       this.inputName = `rating_${this.id}`;
   }
   onClick (rating: number): void
   {
       this.rating = rating;
       this.ratingClick.emit({
           id: this.id,
           rating: rating
       });
   }
}
